/**
 * @ngInject
 */
class BsCarouselItemDirectiveController {
    constructor($element) {
        this.$element = $element;
    }
    $onInit() {
        this.$element.addClass('carousel-item');
    }
}
export function bsCarouselItemDirective() {
    return {
        restrict: 'A',
        require: '^bsCarousel',
        link: function (scope, element, attrs, ctrl) {
            ctrl.register(element);
        },
        controller: BsCarouselItemDirectiveController
    };
}
